export { default } from './component';
export { useCardBody } from './hook';